const sizeConfigs = {
  sidebar: {
    width: "20rem",
    xsWidth: "0rem"
  }
};



export default sizeConfigs;
